import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useGetEmpresasWithConfirmedDealsQuery } from '../../api/empresa/empresaApi';
import { parseTaskDate, reverseDate } from '../../utils/calendarUtils';
import { Dispatch, SetStateAction } from 'react';
import { ConfirmedDealCard } from './ConfirmedDealCard';
import { CircularProgress } from '@mui/joy';

interface Props {
    dateSelected: string;
    setShowModal: Dispatch<SetStateAction<boolean>>;
}

export function ConfirmedDealsContainer({ dateSelected, setShowModal }: Props) {

    const { 
        data: deals,
        isLoading,
    } = useGetEmpresasWithConfirmedDealsQuery(
        dateSelected, 
        { 
            refetchOnMountOrArgChange: true 
        });

    return (
        <div className="bg-white w-3/4 h-3/4 rounded">
            <div className="flex justify-end bg-gray-100 rounded p-2 h-[42px]">
                <button onClick={() => setShowModal(false)}>
                    <CloseRoundedIcon  />
                </button>
            </div>
            {isLoading
            ? 
            <div className="flex justify-center items-center h-full">
                <CircularProgress />
            </div>
            :<div className="p-3 overflow-auto h-[700px]">
                <p className="text-3xl font-semibold">Empresas confirmadas {dateSelected != null ? reverseDate(parseTaskDate(dateSelected)) : ""}</p>
                <div className="my-4">
                    {deals?.length == 0 && (
                    <p className="text-xl font-semibold">No hay campañas confirmadas para este dia</p>
                    )}
                    {deals?.map((deal, index) => (
                        <ConfirmedDealCard 
                            setCloseModal={setShowModal}
                            key={index}
                            deal={deal}/>
                ))}
                </div>
            </div>
            }
        </div>

    );
}